export default __webpack_public_path__ + "static/media/man-carrying-sofa.002e7d6b.svg";